import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const InternalControlNumber = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.internalControlNumber`}
      control={control}
      render={({ field }) => (
        <FF2
          label="66. Internal control/file number"
          field={field}
          input={(props) => <TextInput {...props} maxLength={50} />}
        />
      )}
    />
  )
}
